class Age {
  constructor() {
    this.items = {
      id: 30001,
      name: "Age",
      type: "text",
      slideimg: "/doctorassistant/dia.jpg",
      options: [
        {
          id: 40011,
          text: "Other",
          name: "Other",
          type: "payment",
          desc: "Other",
          inputtype: "textinput",
          key: "age",
          value: "Other",
        },
      ],
      backtostart: false,
      text: [
        `<p>Perfect!. Please enter the age of insured`,
        // `<p>Perfect. You love your vehicle. It must be very costly. Let’s get some more information. Please select the make of your vehicle</p> `,
      ],
    };
  }

  getAllItems() {
    return this.items;
  }
}

export default Age;
